import script from "./PasswordForgotView.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordForgotView.vue?vue&type=script&setup=true&lang=js"

import "./PasswordForgotView.vue?vue&type=style&index=0&id=1e4f9cc5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e4f9cc5"]])

export default __exports__